import { KSIPreloadAPIConfig, KSIPreloadAPIRequestConfig } from '@sailor/ksi-tools-preload-request';
import { SLPreloadBizKFood } from '../Utils/index';
import { CommonHeaders } from '../../../../../pages/shop/c_shop_golden/utils/commonHeaders';
import { SHOPURL, UserGetMode } from '../../../../../pages/shop/c_shop_golden/utils/constant';
import { getShopPreRequestAbTest } from '../../../../../pages/shop/c_shop_golden/utils/exp';

const SLHomeCore = Mach.requireModule('SLHomeCore');
const SLLocation = Mach.requireModule('SLLocation');

const kShopBundleName = 'mach_pro_sailor_c_shop_golden';
// 兼容安卓黄金流程（黄金流程代码未下掉）
const kShopBundleNameV2 = 'mach_pro_sailor_c_shop';
const kShopBundleVersion = '0.1.70';

class SLPreloadShopInfoRequestConfig extends KSIPreloadAPIRequestConfig {
  url(): string {
    return SHOPURL.SHOPINFO;
  }

  body(schemeParams: any): object {
    return this.requestBody(schemeParams);
  }

  headers(): object {
    return CommonHeaders.getCommonHeader();
  }

  needFingerPrint(): boolean {
    return true;
  }

  ignore(schemeParams: any): boolean {
    const channel = schemeParams?.channel || Mach.data?.channel || '';
    const { coreModelStatus } = SLHomeCore?.getCoreInfo?.() || {};
    // BD渠道包跳转打开keeta门店页或核心参数未返回时，不走预请求
    return coreModelStatus !== 2 || channel?.length;
  }

  requestBody = (schemeParams: any, userGetMode?: string) => {
    const locationObj = SLLocation?.getLocation();
    const shopId = schemeParams?.shopId || '';
    const _userGetMode = userGetMode || schemeParams?.userGetMode || UserGetMode.delivery;
    const location = {
      latitude: locationObj?.latitude,
      longitude: locationObj?.longitude,
      actualLatitude: locationObj?.actualLatitude,
      actualLongitude: locationObj?.actualLongitude
    };
    const params = {
      shopId,
      sourcePageType: '0',
      channelId: 'banner-10002',
      userGetMode: _userGetMode,
      bundleVersion: kShopBundleVersion,
      ...location,
    };

    return params;
  }

  handleResponseAvailable(response: any): boolean {
    return response && response.data && response.code === 0;
  }
}

class SLPreloadProductListRequestConfig extends KSIPreloadAPIRequestConfig {
  url(): string {
    return SHOPURL.PRODUCTLIST;
  }

  body(requestParams: any): object {
    return this.requestBody(requestParams);
  }

  headers(): object {
    return CommonHeaders.getCommonHeader();
  }

  needFingerPrint(): boolean {
    return true;
  }

  ignore(schemeParams: any): boolean {
    const channel = schemeParams?.channel || Mach.data?.channel || '';
    const { coreModelStatus } = SLHomeCore?.getCoreInfo?.() || {};
    return coreModelStatus !== 2 || channel?.length;
  }

  requestBody = (schemeParams: any, requestParams?: { userGetMode: string; hasSelectedProduct?: boolean; }) => {
    let selectedProduct;
    const {
      shopId, categoryId, spuId
    } = schemeParams;
    const _userGetMode = requestParams?.userGetMode || schemeParams?.userGetMode || UserGetMode.delivery;
    /**
     * 预请求（肯定是初始化请求）： requestParams 不存在，categoryId 存在（锚点）
     * 非预请求：requestParams?.hasSelectedProduct && categoryId （锚点）
     * 切外卖自提tab：requestParams?.hasSelectedProduct为false （不锚点）
     */
    if ((!requestParams && categoryId) || (requestParams?.hasSelectedProduct && categoryId)) {
      selectedProduct = {
        selectedSource: 0,
        shopCategoryId: categoryId,
        spuId
      };
    }
    const locationObj = SLLocation?.getLocation();
    const location = {
      latitude: locationObj?.latitude,
      longitude: locationObj?.longitude,
      actualLatitude: locationObj?.actualLatitude,
      actualLongitude: locationObj?.actualLongitude
    };
    const params = {
      shopId,
      sourcePageType: '0',
      locationSpuId: '',
      locationCategoryId: '',
      searchWord: '',
      userGetMode: _userGetMode,
      bundleVersion: kShopBundleVersion,
      selectedProduct,
      location,
    };
    return params;
  }

  handleResponseAvailable(response: any): boolean {
    return response && response.data && response.code === 0;
  }
}

class SLPreloadShopAPIConfig extends KSIPreloadAPIConfig {
  shopInfoRequestItem = new SLPreloadShopInfoRequestConfig();
  productListRequestItem = new SLPreloadProductListRequestConfig();
  bizline(): string {
    return SLPreloadBizKFood;
  }

  reqRuleVersion(): string {
    return kShopBundleVersion;
  }

  bundleName(): string {
    return Mach.env.isAndroid ? kShopBundleNameV2 : kShopBundleName;
  }

  // 门店预请求实验
  isHitPreloadApiFFPAB = () => {
    const expKey = getShopPreRequestAbTest() || '';
    return ['A', 'B'].includes(expKey);
  };

  registry(): boolean {
    // true: 走预请求
    return this.isHitPreloadApiFFPAB?.();
  }

  timeoutCallbackDuration(): number {
    return 12000;
  }

  requestItems(): KSIPreloadAPIRequestConfig[] {
    return [
      this.shopInfoRequestItem,
      this.productListRequestItem,
    ];
  }
}

export { SLPreloadShopAPIConfig, SLPreloadShopInfoRequestConfig, SLPreloadProductListRequestConfig };
